export default __webpack_public_path__ + "8ae79657f2f29a1fbba5fac2477cf32d.png";